var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnowledgeGraphBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 23") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.31758781,0.372748336 L11.2135849,1.80353258 C12.2510193,1.97038794 13.3082692,1.97269169 14.346421,1.81035904 L23.6150712,0.361048146 C24.7063797,0.190403531 25.7293948,0.936749056 25.9000394,2.02805753 C25.9160228,2.1302746 25.9240506,2.23357779 25.9240506,2.33703694 L25.9240506,19.4030801 C25.9240506,20.3656702 25.2383511,21.1917092 24.2922105,21.3689027 L14.8695815,23.1335758 C13.6600889,23.36009 12.4191769,23.3614289 11.2091983,23.1375254 L1.63608326,21.3660443 C0.687963148,21.190597 1.4503501e-15,20.3636483 0,19.3994318 L0,2.34737184 C-1.02344917e-15,1.24280234 0.8954305,0.347371841 2,0.347371841 C2.10636898,0.347371841 2.21256846,0.35585759 2.31758781,0.372748336 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-473.000000, -6263.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-23",
    transform: "translate(473.000000, 6263.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    rx: 7
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-35",
    transform: "translate(7.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8923873,9.71832132 L21.6394777,10.4633895 C22.6527797,10.6224299 23.6845187,10.6246263 24.6984887,10.4699018 L29.6983066,9.7069656 C30.7902367,9.54034493 31.8104937,10.2904564 31.9771143,11.3823865 C31.9923496,11.4822289 32,11.5830819 32,11.6840799 L32,21.4984554 C32,22.4643403 31.3097115,23.2922194 30.3595644,23.4658683 L25.1304683,24.4215379 C23.9487378,24.637511 22.7377613,24.6387881 21.5555779,24.4253082 L16.2268648,23.4630435 C15.2747878,23.2911164 14.5822785,22.4623523 14.5822785,21.4948765 L14.5822785,11.6941332 C14.5822785,10.5895637 15.477709,9.69413319 16.5822785,9.69413319 C16.6861193,9.69413319 16.7898024,9.70222035 16.8923873,9.71832132 Z",
    id: "\\u77E9\\u5F62",
    fill: "#1C89B3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u77E9\\u5F62",
    fill: "#12CBDA",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.481013, 6.481013)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    cx: 3.75216522,
    cy: 6.48101266,
    r: 3.75216522
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    cx: 10.7448368,
    cy: 2.21718854,
    r: 2.21718854
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    cx: 10.7448368,
    cy: 9.03930713,
    r: 1.19387075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86114713,1.49637843 C10.2592396,1.19874215 10.8232391,1.28017795 11.1208754,1.67827038 C11.3956166,2.04574031 11.3473614,2.5545749 11.0252014,2.86478177 L10.9389835,2.93799865 L5.781,6.794 L10.97523,8.16929623 C11.4187627,8.286751 11.6968853,8.71557386 11.6369691,9.15877295 L11.6148477,9.26970036 C11.4973929,9.71323305 11.06857,9.99135561 10.625371,9.93143944 L10.5144435,9.90931802 L3.52177199,8.05754329 C2.83250361,7.87501366 2.63130647,7.01504455 3.12457076,6.54182817 L3.21324706,6.46672229 L9.86114713,1.49637843 Z",
    id: "\\u8DEF\\u5F84-43",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeGraphBig);
export default __webpack_public_path__ + "static/media/knowledge_graph_big.fba4f2561f8d87d392b211ddb4cc4813.svg";
export { ForwardRef as ReactComponent };